<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px" id="span-versao">IKPonto -</span>		
		<span class="footer-text" style="margin-left: 5px">Info Kings Sistemas de ponto e acesso LTDA</span>
	</div>
</template>

<script>
import { CHAVE_USUARIO } from '@/global';
export default {
	name: "AppFooter",
	mounted() {		
		let dadosUsuario = JSON.parse(sessionStorage.getItem(CHAVE_USUARIO)); 
		let v = document.getElementById('span-versao').innerHTML;              
		v = v.replace(' -', '');         
		document.getElementById('span-versao').innerHTML = v + ' v' + dadosUsuario.versao + ' -' 
	}		
}
</script>
	
<style scoped>
</style>